import { render, staticRenderFns } from "./IntraoralViewer.vue?vue&type=template&id=e46d9936&scoped=true&"
import script from "./IntraoralViewer.vue?vue&type=script&lang=js&"
export * from "./IntraoralViewer.vue?vue&type=script&lang=js&"
import style0 from "./IntraoralViewer.vue?vue&type=style&index=0&id=e46d9936&prod&scoped=true&lang=css&"
import style1 from "./IntraoralViewer.vue?vue&type=style&index=1&id=e46d9936&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46d9936",
  null
  
)

export default component.exports